
import {zip as observableZip,  Observable } from 'rxjs';
import { Component, OnInit, ViewChild } from '@angular/core';
import { BlockUI } from 'ng-block-ui';
import { LoggedInUserService } from '../../auth/logged.in.user';
import { SearchComponent } from '../../components/common/search/search.component';
import { Configuration } from '../../configuration';
import { CategoryAndLocationHelpers, Helpers } from '../../helpers';
import { AddCustomerHiddenDialogDto, AddCustomerSavedSearchDto, GetCustomerSavedSearchesDto } from '../../models/account/account.models';
import { SelectableCategory } from '../../models/categories/category.models';
import { CmsDialogDto } from '../../models/cms.dialogs/cms.dialogs.models';
import { DateRangeDto, DateRangeModel } from '../../models/common/date.range';
import { SelectableItem } from '../../models/common/selectableItem';
import { ContractAwardEnumsToSelectList, ContractAwardType } from '../../models/contract.awards/contract.award.enums';
import { ContractAwardSearchModel, ContractAwardSearchStorage, ContractAwardSummaryDto } from '../../models/contract.awards/contract.award.models';
import { LocationsByRegionDto, SelectableLocation, SelectableRegion } from '../../models/locations/location.models';
import { NoticeEnumsToSelectList, NoticeStatus } from '../../models/notices/notice.enums';
import { AccountService } from '../../services/account.service';
import { CategoryService } from '../../services/category.service';
import { CmsDialogService } from '../../services/cms.dialog.service';
import { ContractAwardService } from '../../services/contract.award.service';
import { LocationService } from '../../services/location.service';
import { PaidFeatureUpsellService } from '../../services/paid.feature.upsell.service';

@Component({
    selector: 'contractawards/search',
    template: require('./search.component.html'),
    styles: [require('./search.component.css')]
})
export class CaSearchComponent extends SearchComponent<ContractAwardSearchModel,
ContractAwardSummaryDto> implements OnInit {
    showSearch = true;
    hasSearched: boolean = false;
    statuses: Array<SelectableItem<NoticeStatus>>;
    types: Array<SelectableItem<ContractAwardType>>;

    categories: Array<SelectableCategory>;
    locationsByRegion: LocationsByRegionDto;

    options: Array<SelectableItem<string>>;

    datePickerOptions: any;

    resultOptions;

    subscribed: boolean;

    pageSizes = [10, 25, 50];

    publishedDate: DateRangeModel;
    contractStartDate: DateRangeModel;
    contractEndDate: DateRangeModel;

    supplierId: number;

    dialogName: string;
    dialogHeader: string;
    dialogBody: string;

    csvDialogHeader: string;
    csvDialogBody: string;
    csvDialogHidden: boolean;
    csvDialogId: number;

    dialogNameFree: string;
    dialogHeaderFree: string;
    dialogBodyFree: string;


    isExpanded: boolean;
    showSaveSearch: boolean;
    activeTab = 'details';
    selectedTabIndex: number = 0;

    savedSearches: GetCustomerSavedSearchesDto[];

    keyword: string;
    searchName: string;
    clicked: boolean;
    categoryFilter: string;

    private requestStorageKey = 'caSearchRequest';
    private readonly fromUrlKey = 'searchContractAwardId';

    @BlockUI('ca-search-block') private paramsBlock;
    @BlockUI('ca-results-block') private resultsBlock;
    @ViewChild('resultsPage', { static: false }) private resultsView;

    constructor(private readonly contractAwardService: ContractAwardService, helpers: Helpers, configuration: Configuration,
        private categoryService: CategoryService, private locationService: LocationService,
        loggedInUserService: LoggedInUserService, private readonly locCatHelpers: CategoryAndLocationHelpers,
        private readonly cmsDialogService: CmsDialogService, private readonly accountService: AccountService,
        private readonly paidFeatureUpsellService: PaidFeatureUpsellService) {
        super(new ContractAwardSearchModel(configuration), contractAwardService, helpers);

        this.isExpanded = true;
        this.showSaveSearch = false;

        this.publishedDate = new DateRangeModel();
        this.contractStartDate = new DateRangeModel();
        this.contractEndDate = new DateRangeModel();

        var user = loggedInUserService.getCurrentUser();
        this.subscribed = !user.canAdHoc('notSubscribed');
        this.supplierId = user.supplierId;
        this.clicked = false;

        this.datePickerOptions = {
            dateFormat: 'dd/mm/yyyy'
        };

        this.types = ContractAwardEnumsToSelectList.getContractAwardTypes();
        this.setSelectedTypes();
        this.statuses = NoticeEnumsToSelectList.getStatuses();

        this.options = [
            {
                text: 'Most Recent',
                value: 'PublishedDate'
            },
            {
                text: 'Start Date',
                value: 'StartDate'
            },
            {
                text: 'End Date',
                value: 'EndDate'
            },
            {
                text: 'Type',
                value: 'Type'
            },
            {
                text: 'Title',
                value: 'Title'
            }
        ];

        this.statuses = [
            {
                text: 'Live',
                value: NoticeStatus.Live
            },
            {
                text: 'Expired',
                value: NoticeStatus.Expired
            }
        ];

        this.resultOptions = {
            availableButtons: ['print', 'bookmark']
        };

        this.categories = new Array<SelectableCategory>();
    }

    ngOnInit() {
        this.paramsBlock.start();

        var categoryObservable = this.categoryService.getActiveCategories();
        var locationObservable = this.locationService.getActiveLocations();

        observableZip(categoryObservable,
            locationObservable,
            (categories: Array<SelectableCategory>, locations: LocationsByRegionDto) => ({ categories, locations }))
            .subscribe(results => {
                this.categories = results.categories;
                this.locationsByRegion = results.locations;

                const storedRequest = JSON.parse(localStorage.getItem(this.requestStorageKey)) as ContractAwardSearchStorage;

                if (storedRequest) {
                    this.request.setValues(storedRequest);
                    this.publishedDate.setMomentDatesFromStorage(storedRequest.publishedDate);
                    this.contractStartDate.setMomentDatesFromStorage(storedRequest.contractStartDate);
                    this.contractEndDate.setMomentDatesFromStorage(storedRequest.contractEndDate);
                    this.locCatHelpers.setSelectedCategories(this.categories, storedRequest.categoryIds);
                    this.locCatHelpers.setSelectedLocations(this.locationsByRegion, storedRequest.locationIds);

                    this.types.forEach((t: SelectableItem<ContractAwardType>) => {
                        if (this.request.types.indexOf(t.value) > -1) {
                            t.selected = true;
                        } else {
                            t.selected = false;
                        }
                    });
                }

                this.getSavedSearches();

                this.paramsBlock.stop();
            });

        if (this.subscribed) {
            this.dialogName = 'Search Awards Info - Subscribed';
        }
        else {
            this.dialogName = 'Search Awards Info - Not Subscribed';
        }

        this.dialogNameFree = 'Search Awards - No Keywords Free';

        this.cmsDialogService.getByDescription(this.dialogName).subscribe((result: CmsDialogDto) => {
            this.dialogHeader = result.header;
            this.dialogBody = result.body;
        });

        this.cmsDialogService.getByDescription(this.dialogNameFree).subscribe((result: CmsDialogDto) => {
            this.dialogHeaderFree = result.header;
            this.dialogBodyFree = result.body;
        });


        this.cmsDialogService.getByDescription('Search Awards CSV').subscribe((result: CmsDialogDto) => {
            this.csvDialogHeader = result.header;
            this.csvDialogBody = result.body;
            this.csvDialogHidden = result.hidden;
            this.csvDialogId = result.id;
        });

        var selectedId = localStorage.getItem(this.fromUrlKey);

        if (selectedId) {
            this.request.id = JSON.parse(selectedId) as number;
            localStorage.removeItem(this.fromUrlKey);
            this.search();
        }
    }

    ngOnDestroy() {
        $('#search-info-modal').modal('hide');
        $('#search-modal').modal('hide');
        document.body.classList.remove('ca-search-fit');
    }

    private updateSearchFitClass() {
        if (this.hasSearched && !this.isExpanded) {
            document.body.classList.add('ca-search-fit');
        } else {
            document.body.classList.remove('ca-search-fit');
        }
    }

    private getSavedSearches() {
        var eventObservable = this.accountService.getCustomerSavedSearches();

        observableZip(
            eventObservable,
            (savedSearches: GetCustomerSavedSearchesDto[]) => ({ savedSearches }))
            .subscribe(results => {
                this.savedSearches = results.savedSearches.filter(x => x.award);
            });
    }

    runSavedSearch(savedSearch: GetCustomerSavedSearchesDto) {

        this.resetParameters();

        this.request.categoryIds = savedSearch.categoryIds;
        this.request.contractEndDateFrom = savedSearch.contractEndDateFrom;
        this.request.contractEndDateTo = savedSearch.contractEndDateTo;
        this.request.contractStartDateFrom = savedSearch.contractStartDateFrom;
        this.request.contractStartDateTo = savedSearch.contractStartDateTo;
        this.request.keywords = savedSearch.keywords;
        this.request.excludeKeywords = savedSearch.excludeKeywords;
        this.request.locationIds = savedSearch.locationIds;
        this.request.ojeuId = savedSearch.ojeuId;
        this.request.publishedDateFrom = savedSearch.publishedDateFrom;
        this.request.publishedDateTo = savedSearch.publishedDateTo;
        this.request.status = savedSearch.status;
        this.request.types = savedSearch.types;
        this.request.id = savedSearch.noticeId;
        this.request.awardedCompanyEmail = savedSearch.awardedCompanyEmail;
        this.request.awardedCompanyName = savedSearch.awardedCompanyName;
        this.request.buyerContactName = savedSearch.buyerName;
        this.request.buyerEmailAddress = savedSearch.buyerEmail;
        this.request.buyerOrganisationName = savedSearch.buyerOrganisation;

        var dateRange = new DateRangeDto();
        dateRange.startDate = this.request.publishedDateFrom;
        dateRange.endDate = this.request.publishedDateTo;
        this.publishedDate.setMomentDatesFromStorage(dateRange);

        var dateRange = new DateRangeDto();
        dateRange.startDate = this.request.contractStartDateFrom;
        dateRange.endDate = this.request.contractStartDateTo;
        this.contractStartDate.setMomentDatesFromStorage(dateRange);

        var dateRange = new DateRangeDto();
        dateRange.startDate = this.request.contractEndDateFrom;
        dateRange.endDate = this.request.contractEndDateTo;
        this.contractEndDate.setMomentDatesFromStorage(dateRange);

        this.locCatHelpers.setSelectedCategories(this.categories, savedSearch.categoryIds);
        this.locCatHelpers.setSelectedLocations(this.locationsByRegion, savedSearch.locationIds);

        this.types.forEach((t: SelectableItem<ContractAwardType>) => {
            var idx = this.request.types.indexOf(t.value);
            if (idx > -1) {
                t.selected = true;
            } else {
                t.selected = false;
            }
        });

        this.search();
    }

    setSelectedTypes() {
        this.types.forEach((t: SelectableItem<ContractAwardType>) => {
            if (t.value === ContractAwardType.ContractAward || t.value === ContractAwardType.ContractRegistry) {
                t.selected = true;
            } else {
                t.selected = false;
            }
        });
    }

    updateRequestCategoriesSelected() {
        this.categories.forEach((c: SelectableCategory) => {
            this.updateRequestCategory(c);

            c.children.forEach((child: SelectableCategory) => {
                this.updateRequestCategory(child);
            });
        });
    }

    updateRequestCategory(category: SelectableCategory) {
        var idx = this.request.categoryIds.indexOf(category.id);

        if (category.isSelected && idx === -1) {
            this.request.categoryIds.push(category.id);
        } else if (!category.isSelected && idx > -1) {
            this.request.categoryIds.splice(idx, 1);
        }
    }

    setChildrenSelected(category: SelectableCategory) {
        category.children.forEach((child: SelectableCategory) => {
            child.isSelected = category.isSelected;
            this.setChildrenSelected(child);
        });

        var idx = this.request.categoryIds.indexOf(category.id);

        if (category.isSelected && idx === -1) {
            this.request.categoryIds.push(category.id);
        } else if (!category.isSelected && idx > -1) {
            this.request.categoryIds.splice(idx, 1);
        }
    };

    changeRegionSelected(region: SelectableRegion, locationIds: number[]) {
        region.locations.forEach((location: SelectableLocation) => {
            location.isSelected = region.isSelected;
            this.changeLocationSelected(location);
        });
    }

    changeLocationSelected(location: SelectableLocation) {
        var idx = this.request.locationIds.indexOf(location.id);

        if (location.isSelected && idx === -1) {
            this.request.locationIds.push(location.id);
        } else if (!location.isSelected && idx > -1) {
            this.request.locationIds.splice(idx, 1);
        }
    }

    selectAllLocations() {
        this.locationsByRegion.regions.forEach((r: SelectableRegion) => {
            r.isSelected = true;
            this.changeRegionSelected(r, this.request.locationIds);
        });

        this.locationsByRegion.locationsWithoutRegion.forEach((l: SelectableLocation) => {
            l.isSelected = true;
            this.changeLocationSelected(l);
        });
    }

    changeTypeSelected(type) {
        var idx = this.request.types.indexOf(type);

        if (idx > -1) {
            this.request.types.splice(idx, 1);
        } else {
            this.request.types.push(type);
        }
    }

    toggleShowSearch() {
        this.showSearch = !this.showSearch;
    }

    onTabIndexChange(index: number) {
        this.selectedTabIndex = index;

        // Keep legacy property in sync (some flows still reference activeTab)
        if (index === 0) this.activeTab = 'details';
        else if (index === 1) this.activeTab = 'keywords';
        else if (index === 2) this.activeTab = 'categories';
        else if (index === 3) this.activeTab = 'locations';
        else if (index === 4) this.activeTab = 'savedSearches';
    }

    toggleFilters(event?: any) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();

        this.isExpanded = !this.isExpanded;
        this.updateSearchFitClass();
    }

    searchRequested() {
        if (this.request.id && (this.request.id > 2147483647 || this.request.id < 0)) {
            return;
        }

        if ((this.publishedDate.startDate == null ||
            this.publishedDate.endDate == null) &&
            (this.contractStartDate.startDate == null ||
            this.contractStartDate.endDate == null) &&
            (this.contractEndDate.startDate == null ||
                this.contractEndDate.endDate == null)) {

            if (this.subscribed) {
                $('#filters-modal').modal();
                return;
            }
        }

        if (this.request.keywords.length == 0 && this.request.excludeKeywords.length == 0) {

            if (this.subscribed) {
                $('#keywords-modal').modal();
            }
            else {
                $('#keywords-free-modal').modal();
            }
        }
        else {
            this.search();
        }
    }

    showSaveDialog() {
        $('#search-modal').modal();
    }

    showKeywordsTab() {
        $('#keywords-modal').modal('hide');
        this.selectedTabIndex = 1;
        this.activeTab = 'keywords';
    }

    saveSearch() {

        var publishedDateRange = this.publishedDate.convertDatesToDto();
        var contractStartDateRange = this.contractStartDate.convertDatesToDto();
        var contractEndDateRange = this.contractEndDate.convertDatesToDto();

        var dto = new AddCustomerSavedSearchDto();

        dto.publishedDateFrom = publishedDateRange.startDate;
        dto.publishedDateTo = publishedDateRange.endDate;

        dto.contractStartDateFrom = contractStartDateRange.startDate;
        dto.contractStartDateTo = contractStartDateRange.endDate;

        dto.contractEndDateFrom = contractEndDateRange.startDate;
        dto.contractEndDateTo = contractEndDateRange.endDate;
        dto.categoryIds = this.request.categoryIds;

        dto.description = this.searchName;

        dto.keywords = this.request.keywords;
        dto.excludeKeywords = this.request.excludeKeywords;
        dto.locationIds = this.request.locationIds;
        dto.ojeuId = this.request.ojeuId;
        dto.status = this.request.status;
        dto.types = this.request.types;
        dto.noticeId = this.request.id;
        dto.award = true;
        dto.awardedCompanyName = this.request.awardedCompanyName;
        dto.awardedCompanyEmail = this.request.awardedCompanyEmail;
        dto.buyerName = this.request.buyerContactName;
        dto.buyerEmail = this.request.buyerEmailAddress;
        dto.buyerOrganisation = this.request.buyerOrganisationName;

        this.accountService.addCustomerSavedSearch(dto).subscribe(() => {
            $('#search-modal').modal('hide');
            this.paramsBlock.stop();
            this.resultsBlock.stop();
            this.getSavedSearches();
            this.showSaveSearch = false;
            this.resetParameters();
        }, () => {
        });

    }

    search() {
        $('#keywords-modal').modal('hide');

        if (this.request.types.length === 0) {
            return;
        }

        if (this.request.sortProperty == null) {
            this.request.sortProperty = "PublishedDate";
        }        

        this.paramsBlock.start();
        this.resultsBlock.start();

        var requestToStore = new ContractAwardSearchStorage(this.request);
        requestToStore.publishedDate = this.publishedDate.exportDatesForStorage();
        requestToStore.contractStartDate = this.contractStartDate.exportDatesForStorage();
        requestToStore.contractEndDate = this.contractEndDate.exportDatesForStorage();

        localStorage.setItem(this.requestStorageKey, JSON.stringify(requestToStore));

        this.request.supplierId = this.supplierId;

        var publishedDateRange = this.publishedDate.convertDatesToDto();
        var contractStartDateRange = this.contractStartDate.convertDatesToDto();
        var contractEndDateRange = this.contractEndDate.convertDatesToDto();

        this.request.publishedDateFrom = publishedDateRange.startDate;
        this.request.publishedDateTo = publishedDateRange.endDate;

        this.request.contractStartDateFrom = contractStartDateRange.startDate;
        this.request.contractStartDateTo = contractStartDateRange.endDate;

        this.request.contractEndDateFrom = contractEndDateRange.startDate;
        this.request.contractEndDateTo = contractEndDateRange.endDate;

        // Match Tender Search: collapse filters after search
        this.isExpanded = false;
        this.showSaveSearch = true;
        this.hasSearched = true;
        this.updateSearchFitClass();

        return super.search();
    }

    searchCallback(results) {
        super.searchCallback(results);

        if (this.resultsView) {
            this.resultsView.onSearchComplete();
        }

        this.paramsBlock.stop();
        this.resultsBlock.stop();
    }

    resetParameters() {
        this.request.reset();
        this.publishedDate.reset();
        this.contractStartDate.reset();
        this.contractEndDate.reset();

        this.setSelectedTypes();

        this.removeAllLocations();
        this.removeAllCategories();

        this.results = null;
        this.showSaveSearch = false;
        this.hasSearched = false;
        this.updateSearchFitClass();
    }

    clearCategories(event) {
        event.stopPropagation();
        this.request.categoryIds = [];
        this.removeAllCategories();
    }

    clearLocations(event) {
        event.stopPropagation();
        this.request.locationIds = [];
        this.removeAllLocations();
    }

    removeAllCategories() {
        this.categories.forEach((c: SelectableCategory) => {
            c.isSelected = false;

            c.children.forEach((child: SelectableCategory) => {
                child.isSelected = false;
            });
        });
        this.categoryFilter = '';
        this.filterCategories();
    }

    removeAllLocations() {
        this.locationsByRegion.regions.forEach((r: SelectableRegion) => {
            r.isSelected = false;
            this.changeRegionSelected(r, this.request.locationIds);
        });

        this.locationsByRegion.locationsWithoutRegion.forEach((l: SelectableLocation) => {
            l.isSelected = false;
            this.changeLocationSelected(l);
        });
    }

    showSearchInfoDialog() {
        $('#search-info-modal').modal();
    }

    showSaveFreeDialog() {
        this.paidFeatureUpsellService.openDefault();
    }

    showDownloadFreeDialog() {
        this.paidFeatureUpsellService.openDefault();
    }

    removeSavedSearch(id: number) {
        this.accountService.deleteCustomerSavedSearch(id)
            .subscribe(() => {
                //this.ngOnInit();
                this.getSavedSearches();
            });
    }

    includeKeyword(keyword: string) {
        if (keyword.length > 0) {
            keyword.split(/\s*,\s*/).forEach(function (myString) {
                this.request.keywords.push(myString);
            }, this);
            this.keyword = '';
        }
    }

    excludeKeyword(keyword: string) {
        if (keyword.length > 0) {
            keyword.split(/\s*,\s*/).forEach(function (myString) {
                this.request.excludeKeywords.push(myString);
            }, this);
            this.keyword = '';
        }
    }

    removeIncludeKeyword(keyword: string) {
        const index = this.request.keywords.indexOf(keyword);
        if (index > -1) {
            this.request.keywords.splice(index, 1);
        }
    }

    removeExcludeKeyword(keyword: string) {
        const index = this.request.excludeKeywords.indexOf(keyword);
        if (index > -1) {
            this.request.excludeKeywords.splice(index, 1);
        }
    }

    async filterCategories() {
        if (this.categoryFilter && this.categoryFilter.length >= 3) {
            var filter = this.categoryFilter.toLowerCase();
            this.categories.forEach(async (category: SelectableCategory) => {
                await this.checkIfCategoryOrChildrenMatch(category, filter);
            });
        } else {
            this.categories.forEach((category: SelectableCategory) => { this.showCategoryAndChildren(category) });
        }
    }

    async checkIfCategoryOrChildrenMatch(category: SelectableCategory, filter: string, parent?: SelectableCategory) {
        category.show = category.name.toLowerCase().indexOf(filter) > -1 ||
            (category.keywords && category.keywords.indexOf(filter) > -1);

        if (parent && category.show) {
            parent.show = true;
            parent.isExpanded = true;
        }

        category.children.forEach(async (child: SelectableCategory) => {
            await this.checkIfCategoryOrChildrenMatch(child, filter, category);
        });
    }

    async showCategoryAndChildren(category: SelectableCategory) {
        category.show = true;

        category.children.forEach((child: SelectableCategory) => { this.showCategoryAndChildren(child) });
    }

    public downloadCsv(): void {

        if (!this.csvDialogHidden &&
            ((this.results.totalRecords > 200 && this.request.status == NoticeStatus.Live)
                || (this.results.totalRecords > 300 && this.request.status == NoticeStatus.Expired))
        ) {
            $('#search-csv-modal').modal();
        }
        else {
            this.continueDownload();
        }
    }

    public continueDownload(): void {
        $('#search-csv-modal').modal('hide');
        this.clicked = true;
        this.contractAwardService.downloadCsv(this.request);
        this.clicked = false;
    }

    public hideDialog(id: number) {

        var dto = new AddCustomerHiddenDialogDto();
        dto.cMSDialogId = id;

        this.accountService.addCustomerHiddenDialog(dto).subscribe(() => {
            this.csvDialogHidden = true;
            $('#search-csv-modal').modal('hide');
        }, () => {
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/contract.awards/search.component.ts